import React, { createContext, useCallback, useContext, useState } from "react";
import { AlertTriangle } from "lucide-react";

// Modal de confirmação assíncrono — substitui window.confirm().
// `confirmar({ titulo, mensagem, perigo, confirmTexto, cancelarTexto })`
// retorna Promise<boolean>. Modo `perigo` muda o botão pra vermelho.
const ConfirmacaoContext = createContext(null);

export const useConfirmacao = () =>
  useContext(ConfirmacaoContext) ||
  ((cfg) => Promise.resolve(window.confirm(cfg.mensagem || cfg.titulo || 'Confirmar?')));

export const ConfirmacaoProvider = ({ children }) => {
  const [pendente, setPendente] = useState(null);

  const confirmar = useCallback((cfg) => {
    return new Promise((resolve) => {
      setPendente({
        titulo: cfg?.titulo || 'Confirmar ação',
        mensagem: cfg?.mensagem || 'Tem certeza?',
        confirmTexto: cfg?.confirmTexto || 'Confirmar',
        cancelarTexto: cfg?.cancelarTexto || 'Cancelar',
        perigo: !!cfg?.perigo,
        resolve,
      });
    });
  }, []);

  const responder = (ok) => {
    if (pendente) {
      pendente.resolve(ok);
      setPendente(null);
    }
  };

  return (
    <ConfirmacaoContext.Provider value={confirmar}>
      {children}
      {pendente && (
        <div
          className="fixed inset-0 bg-black/50 z-[10000] flex items-center justify-center p-4"
          onClick={() => responder(false)}
        >
          <div
            className="bg-white rounded-2xl max-w-md w-full p-5 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start gap-3 mb-4">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${pendente.perigo ? 'bg-red-100' : 'bg-orange-100'}`}>
                <AlertTriangle size={20} className={pendente.perigo ? 'text-red-600' : 'text-orange-600'} />
              </div>
              <div className="flex-1">
                <h3 className="font-black text-base text-slate-900 mb-1">{pendente.titulo}</h3>
                <p className="text-sm text-slate-600">{pendente.mensagem}</p>
              </div>
            </div>
            <div className="flex gap-2 justify-end">
              <button
                onClick={() => responder(false)}
                className="px-4 py-2 rounded-xl text-sm font-semibold bg-slate-100 text-slate-700 hover:bg-slate-200"
              >{pendente.cancelarTexto}</button>
              <button
                onClick={() => responder(true)}
                className={`px-4 py-2 rounded-xl text-sm font-bold text-white ${pendente.perigo ? 'bg-red-600 hover:bg-red-700' : 'bg-orange-600 hover:bg-orange-700'}`}
              >{pendente.confirmTexto}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmacaoContext.Provider>
  );
};
